import API from '../index';

const validateCoupon = async (orderId: string, couponCode: string): Promise<boolean> => {
  const data = await API.get(`/orders/${orderId}/coupons/${couponCode}/validate`);
  return Boolean(data);
};

export default validateCoupon;
